'use client';

import { Button, type ButtonProps } from '@jouzen/ecom-components/v3/Button';

const LandingPageHeroCtaButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button {...props} data-cy="landing-page-hero-cta">
      {children}
    </Button>
  );
};

export default LandingPageHeroCtaButton;
